import { serviceDocketInventoryCheckStatus } from '../../../common/utils/vending-settings';
import createClientOperationId from '../../../common/utils/createClientOperationId';
import { deepCopy } from '../utils';

/**
 * Offline operation config for confirmStockLevels mutation.
 *
 * Handles:
 * - Queuing stock level confirmations when offline
 * - Optimistically updating the inventory check status to PENDING
 * - Storing machine metadata for display in offline queue
 */
const confirmStockLevelsConfig = {
	serializeVariables: ({ variables }) => deepCopy({
		...variables,
		confirmedAt: variables?.confirmedAt || new Date().toISOString(),
		operationId: variables?.operationId || createClientOperationId('stock-confirmation'),
	}),
	createMeta: ({ variables, context = {} }) => {
		const offlineMeta = context.offlineMeta || {};

		return {
			serviceDocketId: variables?.serviceDocketId,
			type: 'confirmStockLevels',
			machine: offlineMeta.machineDetails || null,
			machineId: offlineMeta.machineId || null,
			fallbackMachineName: offlineMeta.machineName || null,
		};
	},
	applyOptimisticUpdate: async ({ client, variables }) => {
		const cacheId = client.cache.identify({
			__typename: 'ServiceDocket',
			id: variables.serviceDocketId,
		});

		if (!cacheId) {
			return;
		}

		client.cache.modify({
			id: cacheId,
			fields: {
				inventoryCheck: () => serviceDocketInventoryCheckStatus.PENDING,
			},
		});
	},
	getOfflineResult: ({ variables, queueEntry }) => ({
		confirmStockLevels: {
			__typename: 'ServiceDocket',
			id: variables.serviceDocketId,
			inventoryCheck: serviceDocketInventoryCheckStatus.PENDING,
			offlineQueuedAt: queueEntry.createdAt,
			machine: queueEntry.meta?.machine || null,
			offline: true,
		},
	}),
};

export default confirmStockLevelsConfig;
